export default "__VITE_ASSET__DYBuDRl$__"